import { ModalBody, ModalFooter } from 'baseui/modal'
import { Table } from 'baseui/table'
import { useStyletron } from 'baseui'
import PaginationControls from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/PaginationControls'
import BackToSearchButton from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/BackToSearchButton'

const SearchResultsTable = ({
  columns,
  data,
  currentPage,
  totalPages,
  onPageChange,
  onBackToSearch,
  backButtonText,
  t,
  translationPrefix
}) => {
  const [css] = useStyletron()

  return (
    <>
      <ModalBody>
        <div className={css({ padding: '1rem 0' })}>
          <Table
            columns={columns}
            data={data}
            overrides={{
              Root: {
                style: {
                  maxHeight: '400px',
                  overflow: 'auto',
                },
              },
            }}
          />

          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            t={t}
            translationPrefix={translationPrefix}
          />
        </div>
      </ModalBody>

      <ModalFooter
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          backgroundColor: '#f7f7f7',
          borderTop: '1px solid #e0e0e0',
          padding: '16px 24px',
        }}
      >
        <BackToSearchButton onClick={onBackToSearch} text={backButtonText} />
      </ModalFooter>
    </>
  )
}

export default SearchResultsTable
